import { makeStyles } from '@material-ui/core'

/**
 * CKEditor component overridden styles
 */
export const useContentEditorStyles = makeStyles(() => ({
    editorSelectionHandle: {
        // Hide drag/drop handle for tables
        '& .ck.ck-widget__selection-handle': {
            display: 'none',
        },
    },
    editorContent: {
        // Remove spaces before and after paragraphs
        '& .ck.ck-editor__editable_inline > *:first-child': {
            marginTop: 0,
        },
        '& .ck.ck-editor__editable_inline > *:last-child': {
            marginBottom: 0,
        },
    },
    editor: {
        display: 'inline-flex',
        whiteSpace: 'normal',
        verticalAlign: 'baseline',
        alignItems: 'baseline',
        maxWidth: 'none',
        // Base editor styles
        '& .ck.ck-editor__editable': {
            border: 'none',
            padding: 0,
            margin: 0,
            overflow: 'visible',
            background: 'transparent !important',
        },
        // Focused editor styles
        '& .ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable)': {
            border: 'none',
            boxShadow: 'none',
            outline: 'none',
        },
        // Hide toolbar
        '& .ck.ck-sticky-panel': {
            display: 'none',
        },
    },
}))
